function initialOrder() {
	return {
		order_by: 'full_name',
		order_dir: 'asc',
	};
}

function initialFilters() {
	return {
		job_type: null,
		location_type: null,
		relocate: null,
		from_date: null,
		to_date: null,
	};
}

export const state = () => ({
	candidates: [],
	candidate: null,
	search: null,
	filters: initialFilters(),
	order: initialOrder(),
	page: null,
	groups: null,
	groupFiltersEnabled: true,
});

export const mutations = {
	setCandidates(state: any, payload: any) {
		state.candidates = payload;
	},

	setCandidate(state: any, payload: object) {
		state.candidate = payload;
	},

	setFilters(state: any, payload: object) {
		state.filters = payload;
	},

	setGroupFiltersEnabled(state: any, payload: boolean) {
		state.groupFiltersEnabled = payload;
	},

	setGroups(state: any, payload: boolean) {
		state.groups = payload;
	},

	setOrder(state: any, payload: object) {
		state.order = payload;
	},

	setPage(state: any, payload: number | null) {
		state.page = payload;
	},

	setSearch(state: any, payload: string | null) {
		state.search = payload;
	},
};

export const getters = {
	getCandidates: (state: any) => state.candidates,

	getCandidate: (state: any) => state.candidate,

	getFilters: (state: any) => state.filters,

	getOrder: (state: any) => state.order,

	getGroups: (state: any) => state.groups,

	getSearch: (state: any) => state.search,

	groupFiltersEnabled: (state: any) => state.groupFiltersEnabled,

	hasFilters: (state: any) => {
		let data = JSON.parse(JSON.stringify(state.filters));

		Object.keys(data).forEach((key) => !data[key] && delete data[key]);

		const hasFilters = Object.keys(initialFilters()).some((key) => Object.keys(data).includes(key));

		return hasFilters || state.groups?.length;
	},
};

export const actions = {
	createCandidate(state: any, payload: any) {
		const company_uuid = this.$auth.user.company.uuid;

		// Rename the candidate's uuid to candidate_uuid and created_at to registered_at.
		let data = JSON.parse(JSON.stringify(payload));
		Object.assign(data, { candidate_uuid: data.uuid, registered_at: data.created_at });
		['uuid', 'created_at'].forEach((key) => delete data[key]);

		return new Promise((resolve, reject) => {
			this.$axios
				.post(`/api/company/${company_uuid}/head-hunting/candidates`, data)
				.then((res) => {
					state.dispatch('candidates/redactedCandidates/updateCandidateViewedStatus', res.data.candidate_uuid, {
						root: true,
					});

					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	disableGroupFilters(state: any) {
		state.commit('setGroupFiltersEnabled', false);
	},

	enableGroupFilters(state: any) {
		state.commit('setGroupFiltersEnabled', true);
	},

	getCandidates(state: any) {
		const company_uuid = this.$auth.user.company.uuid;

		let data = {
			groups: state.state.groups,
			page: state.state.page,
			search: state.state.search,
			...state.state.order,
			...state.state.filters,
		};

		// Delete empty keys from the posted data
		Object.keys(data).forEach((key) => !data[key] && delete data[key]);

		return new Promise((resolve, reject) => {
			this.$axios
				.get(`/api/company/${company_uuid}/head-hunting/candidates`, { params: { ...data } })
				.then((res) => {
					state.commit('setCandidates', res.data);
					resolve(res.data);
				})
				.catch((err) => reject(err));
		});
	},

	getCandidate(state: any, candidate_uuid: string) {
		const company_uuid = this.$auth.user.company.uuid;

		return new Promise((resolve, reject) => {
			this.$axios
				.get(`/api/company/${company_uuid}/head-hunting/candidates`, {
					params: {
						candidate_uuid: candidate_uuid,
					},
				})
				.then((res) => {
					state.commit('setCandidate', res.data.data[0]);
					resolve(res.data);
				})
				.catch((err) => reject(err));
		});
	},

	updateViewedCandidateGroups(state: any, payload: any) {
		const { viewed_candidate_uuid, ...data } = payload;

		return new Promise((resolve, reject) => {
			this.$axios
				.post(`/api/company/head-hunting/candidates/${viewed_candidate_uuid}/groups`, data)
				.then((res) => {
					const updatedViewedCandidate = res.data;

					// Update the groups for the viewed candidate if it exists in the state.
					let storedViewedCandidates = JSON.parse(JSON.stringify(state.state.candidates));
					let storedViewedCandidate = JSON.parse(JSON.stringify(state.state.candidate));

					storedViewedCandidates.data = storedViewedCandidates?.data?.map((viewedCandidate) => {
						if (viewedCandidate.uuid === updatedViewedCandidate.uuid) {
							viewedCandidate.groups = updatedViewedCandidate.groups;
						}
						return viewedCandidate;
					});

					if (storedViewedCandidate.uuid === updatedViewedCandidate.uuid) {
						storedViewedCandidate.groups = updatedViewedCandidate.groups;
					}

					state.commit('setCandidates', storedViewedCandidates);
					state.commit('setCandidate', storedViewedCandidate);

					resolve(updatedViewedCandidate);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	setFilters(state: any, payload: object) {
		state.commit('setFilters', payload);
	},

	setGroups(state: any, payload: boolean) {
		state.commit('setGroups', payload);
	},

	setOrder(state: any, payload: string) {
		state.commit('setOrder', payload);
	},

	setPage(state: any, payload: number | null) {
		state.commit('setPage', payload);
	},

	setSearch(state: any, payload: string | null) {
		state.commit('setSearch', payload);
		state.commit('setPage', null);
	},

	resetFilters(state: any) {
		state.commit('setFilters', initialFilters());
		state.commit('setPage', null);
	},

	resetOrder(state: any) {
		state.commit('setOrder', initialOrder());
	},

	resetSearch(state: any) {
		state.commit('setSearch', null);
	},

	resetCandidate(state: any) {
		state.commit('setCandidate', null);
	},
};
